export const UPDATE_DASHBOARD = "dashboard/UPDATE_DASHBOARD";
export const CLEAN_DASHBOAD = "dashboard/CLEAN_DASHBOARD";
